module.exports = __webpack_public_path__ + "static/media/toto.10900522.webp";